const listingIdMap: Record<string, string> = {
  prod_itr_salary_prime_l: 'prod_itr_af_basic',
  prod_itr_salary_premium_l: 'prod_itr_af_premium',
  prod_itr_comprehensive_plan_l: 'prod_itr_af_premium',
  prod_cryptocurrency_filing_Traders_l: 'prod_itr_af_premium',
  prod_cryptocurrency_filing_Business_Premium_l: 'prod_itr_af_premium',
  prod_traders_l: 'prod_itr_af_premium',
  prod_itr_presumptive_l: 'prod_itr_af_premium',
  prod_itr_premium_l: 'prod_itr_af_black',
  prod_itr_esop_rsu_l: 'prod_itr_af_black',
  prod_itr_global_citizen_Premium_l: 'prod_itr_af_black',
  prod_itr_global_citizen_l: 'prod_itr_af_black',
};

export function getNewListingId(oldListingId: string): string {
  return listingIdMap[oldListingId] || oldListingId;
}
